import formapipatients from "./patient";


var formattedOutput = null;

const formapimodalpatients = (data) => {
  // Apply formAPIModel to each item in the data array
  formattedOutput = data.map(item => formapipatients(item));


  return formattedOutput
};

export default formapimodalpatients